import { textProcessor } from './textProcessor.js';
export function handleContractError(error, req) {
    var _a, _b, _c, _d, _e;
    if (typeof error === 'string')
        return { message: error };
    if (error === null || error === void 0 ? void 0 : error.message)
        return error;
    if (error === null || error === void 0 ? void 0 : error.Error) {
        return {
            message: error.Error.Details || error.Error.Message || error.Error || error.Status,
            code: error.Error.Code,
        };
    }
    return {
        code: ((_b = (_a = req === null || req === void 0 ? void 0 : req.error) === null || _a === void 0 ? void 0 : _a.message) === null || _b === void 0 ? void 0 : _b.Code) || (req === null || req === void 0 ? void 0 : req.error),
        message: ((_c = req === null || req === void 0 ? void 0 : req.errorMessage) === null || _c === void 0 ? void 0 : _c.message) || ((_e = (_d = req === null || req === void 0 ? void 0 : req.error) === null || _d === void 0 ? void 0 : _d.message) === null || _e === void 0 ? void 0 : _e.Message),
    };
}
export const verifyErrorHandler = (error) => {
    var _a;
    // let _error = isVerifyApiError(error);
    let _error;
    if (error === null || error === void 0 ? void 0 : error.type) {
        _error = error.type;
    }
    else if (typeof error === 'string') {
        _error = error;
    }
    else {
        _error = (error === null || error === void 0 ? void 0 : error.message) || ((_a = error === null || error === void 0 ? void 0 : error.error) === null || _a === void 0 ? void 0 : _a.message) || 'Verify error';
    }
    return _error;
};
export const handleError = (error) => {
    return (error === null || error === void 0 ? void 0 : error.error) || error;
};
export const handleErrorMessage = (error, errorText) => {
    if (error.status === 500) {
        return errorText || 'Failed to fetch data';
    }
    error = handleError(error);
    error = handleContractError(error);
    if (typeof error === 'string')
        errorText = error;
    if (typeof error.message === 'string')
        errorText = error.message;
    return textProcessor.format(errorText || '') || '';
};
export const handleErrorCode = (error) => {
    var _a;
    return (_a = handleError(error)) === null || _a === void 0 ? void 0 : _a.code;
};
export const contractErrorHandler = (error) => {
    var _a, _b;
    if (typeof error === 'string')
        return error;
    return ((_a = error === null || error === void 0 ? void 0 : error.Error) === null || _a === void 0 ? void 0 : _a.Message) || ((_b = error === null || error === void 0 ? void 0 : error.message) === null || _b === void 0 ? void 0 : _b.Message) || (error === null || error === void 0 ? void 0 : error.message) || (error === null || error === void 0 ? void 0 : error.Error);
};
export const getMissParams = (obj) => {
    let _key;
    Object.entries(obj)
        .reverse()
        .map(([key, value]) => {
        if (!value)
            _key = key;
    });
    return _key;
};
export var TipsLevelEnum;
(function (TipsLevelEnum) {
    TipsLevelEnum["log"] = "log";
    TipsLevelEnum["warn"] = "warn";
    TipsLevelEnum["error"] = "error";
    TipsLevelEnum["throwError"] = "throwError";
    TipsLevelEnum["returnError"] = "returnError";
})(TipsLevelEnum || (TipsLevelEnum = {}));
